if (!customElements.get('ir-complete-quick-add')) {
    class IRCompleteQuickAdd extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.trigger = this.querySelector('[data-ir-quick-trigger]');
        this.dialog = this.querySelector('[data-ir-quick-dialog]');
        this.closeButton = this.querySelector('[data-ir-quick-close]');
        this.select = this.querySelector('[data-ir-variant-select]');
        this.variantInput = this.querySelector('input[ref="variantId"]');
        this.onlyVariant = this.querySelector('[data-ir-only-variant]');

        if (this.onlyVariant && this.variantInput) {
          this.variantInput.value = this.onlyVariant.value;
        }

        if (this.dialog && this.trigger) {
          this.trigger.addEventListener('click', this.openDialog);
          this.closeButton?.addEventListener('click', this.closeDialog);
          this.dialog.addEventListener('click', this.handleBackdropClick);
        }

        this.select?.addEventListener('change', this.handleVariantChange);
        this.addEventListener('cart:update', this.handleCartUpdate);
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.openDialog);
        this.closeButton?.removeEventListener('click', this.closeDialog);
        this.dialog?.removeEventListener('click', this.handleBackdropClick);
        this.select?.removeEventListener('change', this.handleVariantChange);
        this.removeEventListener('cart:update', this.handleCartUpdate);
        delete this.dataset.ready;
      }

      openDialog = () => {
        if (!this.dialog) return;
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
      };

      closeDialog = () => {
        if (!this.dialog) return;
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else this.dialog.removeAttribute('open');
      };

      handleBackdropClick = (event) => {
        if (event.target === this.dialog) this.closeDialog();
      };

      handleVariantChange = () => {
        const selected = this.select?.selectedOptions?.[0];
        if (!selected || !this.variantInput) return;

        this.variantInput.value = selected.value;
        const price = selected.dataset.price || '';
        const compareAt = selected.dataset.compareAt || '';
        const card = this.closest('.ir-complete-card');

        this.updatePrice(card?.querySelector('[data-ir-card-price-current]'), card?.querySelector('[data-ir-card-price-compare]'), price, compareAt);
        this.updatePrice(this.querySelector('[data-ir-modal-price-current]'), this.querySelector('[data-ir-modal-price-compare]'), price, compareAt);
      };

      updatePrice(current, compare, price, compareAt) {
        if (current) {
          current.textContent = price;
          current.classList.toggle('is-sale', Boolean(compareAt));
        }
        if (compare) {
          compare.textContent = compareAt;
          compare.hidden = !compareAt;
        }
      }

      handleCartUpdate = (event) => {
        if (event.detail?.data?.didError) return;
        this.closeDialog();

        if (!this.trigger) return;
        const original = this.trigger.textContent;
        this.trigger.textContent = this.dataset.irAddedLabel || 'ADDED ✓';
        this.trigger.classList.add('is-added');
        window.setTimeout(() => {
          if (!this.trigger) return;
          this.trigger.textContent = original;
          this.trigger.classList.remove('is-added');
        }, 1400);
      };
    }

    customElements.define('ir-complete-quick-add', IRCompleteQuickAdd);
  }
